import React, { useState } from "react";
import api from "../services/api";
import "../styles/Report.css";

function truncate(text) {
  if (!text) return "";
  return text.length > 50 ? text.substring(0, 50) + "..." : text;
}

function Report() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);

  // ✅ Paging State
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);

  const handleLogout = () => {
    // remove stored login/session data
    localStorage.clear();
    sessionStorage.clear();

    // redirect to login page
    window.location.href = "/";
  };

  const fetchReport = async () => {
    try {
      const res = await api.get("/api/Report/GetIncomingReport", {
        params: { fromDate, toDate }
      });

      setData(res.data);
      setCurrentPage(1); // reset page on new search
    } catch (err) {
      console.error("Error fetching report:", err);
      alert("Failed to load report");
    }
  };

  // ✅ Paging Calculations
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  return (
    <div className="report-container">
      <div className="report-header">
        <div className="header-top">
          <h2>Feedback Report</h2>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div className="filter-row">
          <label>From:</label>
          <input type="date" onChange={e => setFromDate(e.target.value)} />

          <label>To:</label>
          <input type="date" onChange={e => setToDate(e.target.value)} />

          <button onClick={fetchReport}>Search</button>
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th style={{ width: "200px" }}>Feedback Time</th>
              <th style={{ width: "200px" }}>Customer Number</th>
              <th style={{ width: "260px" }}>May we proceed with a few quick questions? Press 1 for Yes and 2 for No.</th>
              <th style={{ width: "260px" }}>On a scale of 1 to 5, how would you rate your overall experience with us?</th>
              <th style={{ width: "260px" }}>How satisfied were you with the knowledge and support of our sales executive? Please rate from 1 to 5 </th>
              <th style={{ width: "260px" }}>Were you satisfied with the product information and demo experience? Press 1 for Yes, 2 for No</th>
              <th style={{ width: "260px" }}>On a scale of 1 to 5, how likely are you to recommend My Inbox Media to others?</th>
            </tr>
          </thead>

          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row) => (
                <tr key={row.Id}>
                  <td>{row.IvrSTime}</td>
                  <td>{row.CustomerNumber}</td>
                  <td style={{ textAlign: "center" }}>{row.DTMF_1 ?? "-"}</td>
                  <td style={{ textAlign: "center" }}>{row.DTMF_2 ?? "-"}</td>
                  <td style={{ textAlign: "center" }}>{row.DTMF_3 ?? "-"}</td>
                  <td style={{ textAlign: "center" }}>{row.DTMF_4 ?? "-"}</td>
                  <td style={{ textAlign: "center" }}>{row.DTMF_5 ?? "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Pagination Controls */}
      {data.length > rowsPerPage && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            ◀ Prev
          </button>

          <span>Page {currentPage} of {totalPages}</span>

          <button
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next ▶
          </button>
        </div>
      )}
    </div>
  );
}

export default Report;
